var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRamLimiterDisabledMain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 61,
    viewBox: "0 0 61 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "RAM Limiter",
    clipPath: "url(#clip0_301_4928)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.7857 41.0476H51.9286V43.1904H56.2143V17.4761H4.78571V43.1904H34.7857V41.0476ZM0.5 13.1904V47.4761H39.0714V45.3333H47.6429V47.4761H60.5V13.1904H0.5Z",
    fill: "#5C4E7E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.07143 43.1904L9.07143 30.3333H13.3571V43.1904H9.07143Z",
    fill: "#5C4E7E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.6429 43.1904V30.3333H21.9286V43.1904H17.6429Z",
    fill: "#5C4E7E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.2143 43.1904V30.3333H30.5V43.1904H26.2143Z",
    fill: "#5C4E7E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.5 30.3333L39.0714 30.3333V34.619L0.5 34.619L0.5 30.3333Z",
    fill: "#5C4E7E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.6429 30.3333H60.5V34.619L47.6429 34.619V30.3333Z",
    fill: "#5C4E7E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.7857 43.1904V30.3333L39.0714 30.3333V43.1904H34.7857Z",
    fill: "#5C4E7E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.6429 43.1904V30.3333H51.9286V43.1904H47.6429Z",
    fill: "#5C4E7E"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_301_4928"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white",
    transform: "translate(0.5 0.333252)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRamLimiterDisabledMain);
export default __webpack_public_path__ + "static/media/ramLimiterDisabledMain.bc78f74cda1c26fb42054e4c2f1b46ba.svg";
export { ForwardRef as ReactComponent };